export const lineHeights = {
  shorter: '1.25rem',
  short: '1.4rem',
  base: '1.5rem',
  tall: '1.8rem',
  'extra-tall': '2.25rem',
  extra: '2.4rem',
};
